import { isUndefined } from 'lodash'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'

import { fetchInstallation } from '../../installations/api/installation.api'
import { Installation } from '../../installations/models/installation.model'
import { usePortalQuery } from 'src/Libs/api'

type RefetchFunction = () => void

type DataReturnType = [Installation | null, boolean, RefetchFunction, boolean]

export const detailedInstallationQueryKey = (installationId?: number) => ['installation', installationId] as const

/**
 * Hook to get installation data by installation id
 * @param installationId - installation id
 * @param enabled - custom enabled param
 * @param log - custom log function
 */
export const useDetailedInstallationData = (installationId?: string, enabled?: boolean, log?: (value: string) => void): DataReturnType => {
  const authFetch = useAuthFetchWithResponse()
  const installationIdToUse = installationId ? parseInt(installationId) : undefined

  const fetchInstallationQueryFn = async (): Promise<Installation | null> => {
    const { error, hasErrors, value } = await fetchInstallation(installationIdToUse, authFetch, log) // Error: Argument of type 'number | undefined' is not assignable to parameter of type 'number'.
    if (hasErrors) {
      throw error || new Error('An unexpected error occurred while fetching installation data')
    }

    return value
  }

  const {
    data: installation,
    isLoading: installationLoading,
    isError,
    refetch,
  } = usePortalQuery({
    queryKey: detailedInstallationQueryKey(installationIdToUse),
    queryFn: fetchInstallationQueryFn,
    enabled: isUndefined(enabled) ? !!installationIdToUse : enabled,
  })

  return [installation || null, installationLoading, refetch as RefetchFunction, isError]
}
